import Offcanvas from 'react-bootstrap/Offcanvas'

import { Spinner } from '../LoadingContainer/Spinner'
import { FeedCard, ReleaseHeading } from './FeatureViews'

const WhatsNewFeed = ({
  show,
  loading,
  releases,
  onHide,
  onWatch,
  onLook,
  onAction,
  onEdit,
}) => (
  <Offcanvas
    show={show}
    onHide={onHide}
    placement="end"
    className="whats-new-feed"
    aria-labelledby="whats-new-feed-title"
  >
    <Offcanvas.Header closeButton>
      <div>
        <Offcanvas.Title as="h2" id="whats-new-feed-title">
          What's new
        </Offcanvas.Title>
        <p className="whats-new-feed__subtitle">
          Everything added to your admin, newest first.
        </p>
      </div>
    </Offcanvas.Header>
    <Offcanvas.Body>
      {loading && (
        <div className="whats-new-feed__loading" role="status">
          <Spinner variant="primary" size="lg" />
          <span className="visually-hidden">Loading</span>
        </div>
      )}
      {!loading && !releases.length && (
        <p className="text-muted">Nothing new yet.</p>
      )}
      {releases.map((release, index) => (
        <section key={release.id || release.publishedOn}>
          <ReleaseHeading release={release} latest={index === 0} />
          {release.features.map((feature) => (
            <FeedCard
              key={feature.slug}
              feature={feature}
              onWatch={() => onWatch(feature)}
              onLook={() => onLook(feature)}
              onAction={() => onAction(feature)}
              onEdit={onEdit ? () => onEdit(feature) : undefined}
            />
          ))}
        </section>
      ))}
    </Offcanvas.Body>
  </Offcanvas>
)

export default WhatsNewFeed
